import {Component, OnDestroy, OnInit} from '@angular/core';
import { HttpClient} from '@angular/common/http';
import {DataService} from '../../services/data.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription} from 'rxjs';

@Component({
  selector: 'app-status-card',
  templateUrl: './status-card.component.html',
  styleUrls: ['./status-card.component.scss']
})
export class StatusCardComponent implements OnInit, OnDestroy {
  totalAmount: any;
  policyAnnualPremium: any;
  fraudDetected: any;
  dataSet: any;
  statesValues: any;
  observable: Subscription;
  constructor(private http: HttpClient, private dataService: DataService, private route: ActivatedRoute, private router: Router,
  ) { }

  ngOnInit() {
    this.totalAmount = 0;
    this.policyAnnualPremium = 0;
    this.fraudDetected = 0;
    this.observable = this.dataService.message.subscribe( data => {
      this.totalClaimAmount(data);
    });
  }
  ngOnDestroy(): void {
    this.dataService.message.emit({ value: 0, remove: true });
    this.observable.unsubscribe();
  }

  totalClaimAmount(data) {
    this.statesValues = data['value'];
    this.totalAmount = 0;
    this.policyAnnualPremium = 0;
    this.fraudDetected = 0;
    this.dataSet = [[37867320, 39038474, 247], [36479782, 37608022, 150]];
    this.totalAmount = this.dataSet[this.statesValues][0];
    this.policyAnnualPremium = this.dataSet[this.statesValues][1];
    this.fraudDetected = this.dataSet[this.statesValues][2];
  }
  fraudConsoleLoad() {
    // this.dataService.fraudchange.emit();
    this.router.navigate(['../fraud-report-data']);
  }
}
